import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import PropTypes from 'prop-types';
import VideoAdsInterface from '../../api/VideoAdsInterface';
import Utils from '../../utils';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import audio from '../../utils/audio';
import TimestampManager from '../../utils/TimestampManager';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var VideoAds = /*#__PURE__*/function (_Component) {
  _inherits(VideoAds, _Component);

  var _super = _createSuper(VideoAds);

  function VideoAds(props) {
    var _this;

    _classCallCheck(this, VideoAds);

    _this = _super.call(this, props);
    _this.hasSeenCongratsModal = false;
    _this._initializeVideo = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var startVideoResonponse, url, webUrl, reward, videoId, eventPayload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return VideoAdsInterface.startVideo();

            case 3:
              startVideoResonponse = _context.sent;
              url = startVideoResonponse.url, webUrl = startVideoResonponse.web_url, reward = startVideoResonponse.reward, videoId = startVideoResonponse.videoId;
              eventPayload = {
                id: videoId
              };
              Logger.sendEvent(EVENT_TYPES.AD_STARTED, eventPayload);

              _this.setState({
                url: Utils.getPlatform() === 'web' ? webUrl : url,
                reward: {
                  amount: format(reward.amount),
                  currency: reward.currency
                },
                videoId: videoId
              });

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);

              _this.setState({
                error: true,
                errorMessage: _context.t0.message
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    _this.setCompleted = function () {
      var videoId = _this.state.videoId;
      var eventPayload = {
        id: videoId
      };
      Logger.sendEvent(EVENT_TYPES.AD_FINISHED, eventPayload);

      _this.setState({
        completed: true
      });
    };

    _this.showModal = function (modalType) {
      var _QueryParamsProxy$set;

      audio.onClick();
      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set = {}, _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_MODAL, modalType), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_VIDEO_REWARD_AMOUNT, format(_this.state.reward.amount)), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_VIDEO_REWARD_CURRENCY, _this.state.reward.currency), _QueryParamsProxy$set));
    };

    _this.setHasSeenCongratsModal = function (value) {
      _this.hasSeenCongratsModal = value;
    };

    _this.startTimer = function (videosLeftCount, secondsUntilReset, setVideosAdsInfo) {
      if (videosLeftCount === 0) {
        _this.videoTimer = TimestampManager.register(secondsUntilReset * 1000, function () {
          setVideosAdsInfo({
            remaining: videosLeftCount + 1,
            secondsUntilReset: 0
          });
        });
      }
    };

    _this.collectHandler = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
        var reward, _this$props, setVideosAdsInfo, coins, completeVideoResponse, success, videosLeftCount, secondsUntilReset, videoId, _QueryParamsProxy$set2, rewardAmount, eventPayload;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                audio.onClick();
                audio.playCoinSfx();
                reward = _this.state.reward;
                _this$props = _this.props, setVideosAdsInfo = _this$props.setVideosAdsInfo, coins = _this$props.coins;

                if (!value) {
                  _context2.next = 16;
                  break;
                }

                _context2.prev = 5;
                _context2.next = 8;
                return VideoAdsInterface.completeVideo();

              case 8:
                completeVideoResponse = _context2.sent;
                success = completeVideoResponse.success, videosLeftCount = completeVideoResponse.videos_left_count, secondsUntilReset = completeVideoResponse.seconds_until_reset, videoId = completeVideoResponse.videoId;

                if (success) {
                  _this.setState({
                    rewardCollected: true
                  });

                  setVideosAdsInfo({
                    remaining: videosLeftCount,
                    secondsUntilReset: secondsUntilReset
                  });

                  if (parseInt(videosLeftCount) === 0) {
                    _this.startTimer(videosLeftCount, secondsUntilReset, setVideosAdsInfo);
                  }

                  rewardAmount = parseInt(reward.amount, 10);
                  eventPayload = {
                    balance_before: (coins - rewardAmount).toString(),
                    coins: rewardAmount.toString(),
                    remaining: videosLeftCount,
                    id: videoId
                  };
                  Logger.sendEvent(EVENT_TYPES.AD_BONUS_CLAIMED, eventPayload);
                  QueryParamsProxy.setQueryParams((_QueryParamsProxy$set2 = {}, _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_MODAL, undefined), _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_VIDEO_REWARD_AMOUNT, undefined), _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_VIDEO_REWARD_CURRENCY, undefined), _QueryParamsProxy$set2));
                  QueryParamsProxy.modalPromiseAccept();
                }

                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](5);
                console.log(_context2.t0);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[5, 13]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.state = {
      url: null,
      reward: {
        amount: 0,
        currency: 'coins'
      },
      completed: false,
      rewardCollected: false,
      error: false,
      errorMessage: '',
      videoId: undefined
    };
    _this.videoTimer = null;
    _this.state.reward.amount = QueryParamsProxy.findParam(RouteParamConstants.PARAM_VIDEO_REWARD_AMOUNT, 0);
    _this.state.reward.currency = QueryParamsProxy.findParam(RouteParamConstants.PARAM_VIDEO_REWARD_CURRENCY, 'coins');
    return _this;
  }

  _createClass(VideoAds, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.hasSeenCongratsModal) {
        this._initializeVideo();

        TimestampManager.unregister(this.videoTimer);
        audio.pauseMusic();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);

      if (this.hasSeenCongratsModal && !this.state.rewardCollected) {
        this.collectHandler(true);
      }

      audio.playMusic('backgroundMusic');
    }
  }, {
    key: "render",
    value: function render() {
      var render = this.props.render;
      var _this$state = this.state,
          url = _this$state.url,
          reward = _this$state.reward,
          completed = _this$state.completed,
          error = _this$state.error,
          errorMessage = _this$state.errorMessage;
      return render({
        url: url,
        reward: reward,
        completed: completed,
        error: error,
        errorMessage: errorMessage,
        setCompleted: this.setCompleted,
        collectHandler: this.collectHandler,
        showModal: this.showModal,
        setHasSeenCongratsModal: this.setHasSeenCongratsModal
      });
    }
  }]);

  return VideoAds;
}(Component);

export { VideoAds as default };
VideoAds.propTypes = {
  render: PropTypes.isRequired,
  setVideosAdsInfo: PropTypes.isRequired,
  coins: PropTypes.isRequired
};